import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import BackButton from 'app/Components/Shared/BackButton/BackButton';
import {backButtonVisibleSteps, stepEnum} from '../Constants/debtPaymentEnum';
import {backHistory, selectCurrentStep} from '../DebtAndUpdatePaymentBlockSlice';
import {resetStore as resetCGStore} from '../../SaleBlock/PaymentCG/PaymentCGSlice';

const BackButtonComponent = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector(selectCurrentStep);
  const isBackButtonVisible = backButtonVisibleSteps.includes(currentStep);

  function handleBack() {
    if (currentStep === stepEnum.CREDITCARD) {
      dispatch(resetCGStore());
    }
    dispatch(backHistory());
  }

  return isBackButtonVisible ? <BackButton onClick={handleBack} /> : null;
};

export default BackButtonComponent;
